import React from "react";
import { CircularProgress, withStyles } from "@material-ui/core";
import Body from "@components/typography/Body";
import { ThemeType, Classes } from "@theme";
import locale from "@bonliva-crm/locale";
import { SortOptions, SortOption } from "@search/SortOptions";

type Props = {
  classes: Classes<typeof styles>;
  actions?: JSX.Element[];
  onSortOption?: (value: SortOption) => void;
  sortOptions?: SortOption[];
  style?: React.CSSProperties;
  total?: React.ReactNode;
  totalLoading?: boolean;
  withTotalLabel?: boolean;
};

class ActionBar extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    sortOptions: [],
    withTotalLabel: true
  };

  render() {
    const { actions, classes, total, withTotalLabel } = this.props;

    return (
      <div className={classes.root} style={this.props.style} data-test="ActionBar">
        <div className={classes.leftPane}>{actions}</div>

        <div className={classes.rightPane}>
          <SortOptions
            sortOptions={this.props.sortOptions}
            onSortOption={this.props.onSortOption}
          />

          {total != null && withTotalLabel && (
            <div>
              <Body>
                {locale.Total}:&nbsp;<strong>{total}</strong>
              </Body>
            </div>
          )}

          {this.props.totalLoading && (
            <div>
              {this.props.withTotalLabel && <Body display="inline">{locale.Total}: &nbsp;</Body>}
              <CircularProgress color="secondary" size={16} />
            </div>
          )}

          {total != null && !withTotalLabel && total}
        </div>
      </div>
    );
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    ...theme.fixedGrid,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),

    alignItems: "center",
    display: "flex",
    justifyContent: "space-between"
  },

  label: {
    display: "inline-block",
    marginRight: theme.spacing()
  },

  leftPane: {
    ...theme.mixins.childrenMarginRight(theme.spacing()),
    flex: "1 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  rightPane: {
    ...theme.mixins.childrenMarginRight(theme.spacing()),
    alignItems: "center",
    display: "flex",
    flex: "1 0 0",
    justifyContent: "flex-end"
  }
});

export default withStyles(styles as any)(ActionBar);
